import { ComponentProps, FC } from "react";
import styled, { css } from "styled-components";
import { ButtonSpinner, PrimaryButton, StyledButton } from "./PrimaryButton";
import { WhiteIcon } from "../Icon";

const baseStyles = css`
  color: var(--color-neutral-000-full);
  background: var(--color-error-600);
  border: 1px solid var(--color-error-600);
`;

export const StyledDangerButton = styled(StyledButton)`
  ${baseStyles}

  :not(:disabled) {
    &:active {
      ${baseStyles}
    }
    &:hover {
      background: var(--color-error-500);
      border: 1px solid var(--color-error-500);
    }
  }

  :disabled.loading {
    background-color: var(--color-error-200);
    border: 1px solid var(--color-error-200);
  }
`;

type DangerButtonProps = Omit<ComponentProps<typeof PrimaryButton>, "active">;

export const DangerButton: FC<DangerButtonProps> = ({
  children,
  iconName,
  secondaryIconName,
  disabled,
  loading,
  className = "",
  ...buttonProps
}) => {
  return (
    <StyledDangerButton
      {...buttonProps}
      disabled={disabled || loading}
      className={loading ? `loading ${className}` : className}
    >
      {loading && <ButtonSpinner />}
      {iconName && <WhiteIcon iconName={iconName} iconSize="small" plain />}
      <span>{children}</span>
      {secondaryIconName && (
        <WhiteIcon iconName={secondaryIconName} iconSize="small" plain />
      )}
    </StyledDangerButton>
  );
};
